import React, { useState, useEffect } from 'react';
import { Loading } from 'react-lib/dist/components-es';

import { Grid, Segment, Table } from 'semantic-ui-react';

import OverviewTableHeader from './OverviewTableHeader';
import OverviewTableBody from './OverviewTableBody';
import OverviewFooter from './OverviewFooter';
import OverviewHeader from './OverviewHeader';
import { wrapConsumer } from '../FilteringContextProvider';
import { useTitleDispatch } from '../../TitleContextProvider';
import {dbFieldType, defaultFilterColumn, entityType as et} from '../../../constants';
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import {connect} from "react-redux";

const OverviewTable = ({
  id,
  filterProps,
  renderColumnSelector,
  renderRowComparator,
  clearColumnsDefaultValues,
  renderSorting,
  renderSelection,
  renderRecordsPerPage,
  renderSelectedRowsCounter,
  selectedRows,
  setSelectedRows,
  entityType,
  inventoryState,
}) => {
  const { filteredList } = filterProps || {};
  const [allRowsSelected, setAllRowsSelected] = useState(false);
  const [, forceUpdate] = useState();
  const dispatch = useTitleDispatch();

  useEffect(() => {
    if (Object.keys(selectedRows).length === 0) {
      setAllRowsSelected(false);
    }
  }, [selectedRows]);

  const onRowSelectHandler = (event, entry, isTriggeredByCheckBox) => {
    event.stopPropagation();

    if (!renderSelection) {
      return;
    }

    if (event.ctrlKey || (isTriggeredByCheckBox && event.target.id.includes('selection'))) {
      if (selectedRows[entry.ID]) {
        delete selectedRows[entry.ID];
        setAllRowsSelected(false);
      } else {
        selectedRows[entry.ID] = true;
      }
      setSelectedRows(selectedRows);
      forceUpdate(n => !n);
    }

    if (et.inventory === entityType) {
      dispatch(prevState => ({ ...prevState, selectedRowsForBatchUpdate: selectedRows }));
    }
  };

  const onSelectAllRows = () => {
    if (Object.keys(selectedRows).length > 0 && allRowsSelected) {
      setSelectedRows({});
      setAllRowsSelected(false);
    } else {
      filteredList.result.forEach(entry => {
        selectedRows[entry.ID] = true;
      });
      setSelectedRows(selectedRows);
      setAllRowsSelected(true);
    }
    forceUpdate(n => !n);

    if (et.inventory === entityType) {
      dispatch(prevState => ({ ...prevState, selectedRowsForBatchUpdate: selectedRows }));
    }
  };
  const isLoading = filterProps.isLoadingFilter || (entityType === et.inventory && inventoryState.isLoading)

  let isHasAnyActionRequiredRecord = false;

  for (let entry of filteredList.result) {
    if(et.inventory && entry[defaultFilterColumn.GEN_IS_CHECK_VALID] === dbFieldType.false){
      isHasAnyActionRequiredRecord = true;
      break;
    }
  }

  return (
    <Segment basic>
      <Grid stackable>
        <Loading isLoading={isLoading} />
        <OverviewHeader
          setAllRowsSelected={setAllRowsSelected}
          renderColumnSelector={renderColumnSelector}
          renderRowComparator={renderRowComparator}
          clearColumnsDefaultValues={clearColumnsDefaultValues}
          selectedRows={selectedRows}
        />
        <Grid.Row className="notPaddedSegment smallScreenReduceTopBottomRowPadding">
          <Grid.Column style={{ padding: '0px' }}>
            <Table
              id={id}
              celled
              striped
              compact="very"
              fixed
              singleLine
              selectable={renderSelection}
            >
              <OverviewTableHeader
                renderSorting={renderSorting}
                renderSelection={renderSelection}
                selectedRows={selectedRows}
                allRowsSelected={allRowsSelected}
                onSelectAllRows={onSelectAllRows}
                isHasAnyActionRequiredRecord={isHasAnyActionRequiredRecord}
              />
              <OverviewTableBody
                renderSelection={renderSelection}
                selectedRows={selectedRows}
                onRowSelectHandler={onRowSelectHandler}
                isHasAnyActionRequiredRecord={isHasAnyActionRequiredRecord}
              />
            </Table>
          </Grid.Column>
        </Grid.Row>
        <OverviewFooter
          renderRecordsPerPage={renderRecordsPerPage}
          selectedRows={selectedRows}
          setAllRowsSelected={setAllRowsSelected}
          renderSelection={renderSelection}
          renderSelectedRowsCounter={renderSelectedRowsCounter}
        />
      </Grid>
    </Segment>
  );
};
OverviewTable.defaultProps = {
  renderColumnSelector: true,
  renderSorting: true,
  renderSelection: true,
  selectedRows: {}
};

const mapStateToProps = state => ({
  inventoryState: state.inventories,
});

export default compose(withTranslation(), connect(mapStateToProps, null))(wrapConsumer(OverviewTable));
